const Cart = () => {
    const couponForm = document.querySelector('.woocommerce-cart-form');
    
    if (couponForm) {
        couponForm.addEventListener('submit', (event) => {
            const couponInput = document.getElementById('coupon_code').value;
            if (couponInput !== "") {
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        });
    }

    const handleIncreaseClick = (input) => {
        updateQuantity(input, 1);
        triggerCartUpdate();
        updateButtonTextInSingle();
        updateOptions();
    };

    const handleDecreaseClick = (input) => {
        updateQuantity(input, -1);
        triggerCartUpdate();
        updateButtonTextInSingle();
        updateOptions();
    };

    const handleInputChange = () => {
        triggerCartUpdate();
        updateButtonTextInSingle();
        updateOptions();
    };

    function updateOptions() {
        const quantityInput = document.querySelector(".input-text.qty");
        const selectElement = document.getElementById("bos4w-dropdown-plan");
        const quantity = parseInt(quantityInput.value, 10) || 1;
    
        if (!selectElement) return;
    
        selectElement.querySelectorAll("option").forEach(option => {
            // Zapisujemy oryginalny tekst opcji, jeśli jeszcze nie został zapisany
            if (!option.hasAttribute("data-original-text")) {
                option.setAttribute("data-original-text", option.innerHTML);
            }
    
            const originalText = option.getAttribute("data-original-text");
    
            // Usuwamy stare "x ilość" przed dodaniem nowego
            let newText = originalText.replace(/(&nbsp;zł) x \d+/, "$1").replace(/(&nbsp;zł)/, `$1 x ${quantity}`);
    
            option.innerHTML = newText;
        });
    }

    const initQuantityEvents = () => {
        const quantityWrappers = document.querySelectorAll('.quantity-wrapper');

        quantityWrappers.forEach(wrapper => {
            const input = wrapper.querySelector('input.qty');
            const increaseBtn = wrapper.querySelector('.quantity-increase');
            const decreaseBtn = wrapper.querySelector('.quantity-decrease');

            if (input && increaseBtn && decreaseBtn) {
                increaseBtn.removeEventListener('click', increaseBtn._listener);
                decreaseBtn.removeEventListener('click', decreaseBtn._listener);
                input.removeEventListener('change', input._listener);

                increaseBtn._listener = () => handleIncreaseClick(input);
                decreaseBtn._listener = () => handleDecreaseClick(input);
                input._listener = handleInputChange;

                increaseBtn.addEventListener('click', increaseBtn._listener);
                decreaseBtn.addEventListener('click', decreaseBtn._listener);
                input.addEventListener('change', input._listener);
            }
        });
    };

    const updateQuantity = (input, change) => {
        let currentValue = parseInt(input.value);
        let newValue = currentValue + change;
        const min = parseInt(input.getAttribute('min')) || 1;
        const max = parseInt(input.getAttribute('max')) || Infinity;

        if (newValue < min) newValue = min;
        if (newValue > max) newValue = max;

        input.value = newValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateButtonTextInSingle = () => {
        if (document.body.classList.contains('single-product')) {
            const subwrapper = document.querySelector('.bos4w-display-wrap');
            const addToCartButton = document.querySelector('.single_add_to_cart_button');
            const discountDataElement = document.querySelector('#discount-data');
            const quantityInput = document.querySelector('.quantity-wrapper input.qty');
    
            if (!subwrapper.classList.contains('active')) {
                if (addToCartButton && discountDataElement && quantityInput) {
                    const discounts = JSON.parse(discountDataElement.getAttribute('data-discounts'));
                    const quantity = parseInt(quantityInput.value, 10) || 0;
                    let buttonText = 'Kup teraz';
    
                    discounts.forEach(discount => {
                        if (quantity >= discount.threshold) {
                            if (discount.type === 'fixed') {
                                buttonText = `Kup teraz i zyskaj ${discount.value} zł`;
                            } else if (discount.type === 'percentage') {
                                buttonText = `Kup teraz i zyskaj ${discount.value}%`;
                            }
                        }
                    });
    
                    // Modyfikuj wyłącznie tekst węzła potomnego
                    const textNode = Array.from(addToCartButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
                    if (textNode) {
                        textNode.textContent = buttonText;
                    }
                }
            }
        }
    };

    const triggerCartUpdate = () => {
        const updateCartButton = document.querySelector('button[name="update_cart"]');
        if (updateCartButton) {
            setTimeout(() => updateCartButton.click(), 100);
        }
    };

    const cartObserver = new MutationObserver(() => {
        cartObserver.disconnect();
        initQuantityEvents();
        observeCart();
    });

    const observeCart = () => {
        const woocommerceCart = document.querySelector('.woocommerce-cart-form');
        if (woocommerceCart) {
            cartObserver.observe(woocommerceCart, {
                childList: true,
                subtree: true,
                attributes: true,
            });
        }
    };

    // Wywołanie na starcie
    initQuantityEvents();
    observeCart();

    const toggleSection = (checkbox, targetSection) => {
        if (!checkbox || !targetSection) return;
    
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                if(targetSection.classList.contains('invoice-fields-wrapper')) {
                    targetSection.style.display = 'flex';
                } else {
                    targetSection.style.display = 'block';
                }
            } else {
                targetSection.style.display = 'none';
            }
        });
    };

    toggleSection(
        document.getElementById('ship-to-different-address-checkbox'),
        document.querySelector('.shipping_address-custom')
    );

    toggleSection(
        document.getElementById('want_invoice'),
        document.querySelector('.invoice-fields-wrapper')
    );

    const miniCartToggle = () => {
        const miniCartOpen = document.querySelectorAll('.header__wrapper-right-cart');
        const closeMiniCart = document.querySelector('.sidebar-cart__wrapper-close');
        const sidebar = document.querySelector('.sidebar-cart');
        const continueShoping = document.querySelector('.button.continue-purchase');

        if(continueShoping) {
            continueShoping.addEventListener('click',function() {
                if(sidebar) {
                    sidebar.classList.remove('active');
                }
            })
        }

        miniCartOpen?.forEach(element => {
            element.addEventListener('click', () => sidebar?.classList.add('active'));
        });

        closeMiniCart?.addEventListener('click', () => sidebar?.classList.remove('active'));

        sidebar?.addEventListener('click', (event) => {
            if (event.target.classList.contains('sidebar-cart')) {
                sidebar.classList.remove('active');
            }
        });
    };

    miniCartToggle();

    const couponTop = document.querySelector('.coupon__wrapper-top');
    const couponFormWrapper = document.querySelector('.coupon__wrapper-form');

    if (couponTop) {
        couponTop.addEventListener('click', function () {
            if (couponFormWrapper.style.maxHeight) {
                couponFormWrapper.style.maxHeight = null;
            } else {
                couponFormWrapper.style.maxHeight = couponFormWrapper.scrollHeight + 'px';
            }
        });
    }
};

export default Cart;
